import React from 'react';
import {DefaultPage} from '../../../../../Components/DefaultPage';
import {ReciteQuran} from '../../../../../Components/ReciteQuran';
import {HeadFC} from 'gatsby';
import {SEO} from '../../../../../Components/SEO';
import {ReadProgress} from '../../../../../Components/ReadProgress';
import {ArticleHeader} from '../../../../../Components/ArticleHeader';
import {StaticImage} from 'gatsby-plugin-image';
import {ArticleBlock} from '../../../../../Components/ArticleBlock';
import {FinishArticle} from '../../../../../Components/FinishArticle';
export default function OSignificadoDoTestemunho() {
  return (
    <DefaultPage>
      <ReadProgress />
      <ArticleHeader
        h1="O significado do Testemunho de Fé"
        h2=""
        headerImage={
          <StaticImage
            src="../../../../../assets/images/shahada/shahada_fundo-verde.jpg"
            alt="Shahada"
          />
        }
      />
      <div className="container">
        <ArticleBlock
          text={
            <>
              <h3>Introdução</h3>
              <p>
                O testemunho de fé é o critério definitivo pelo qual o homem é
                considerado um muçulmano ou um kafir.
              </p>
              <p>
                Este testemunho é o fundamento sobre o qual se assenta o Islam.
              </p>
              <p>
                O conceito de vida, o universo e o homem advém dele e sobre ele
                está assentado e é nele que se baseia a mensagem de todos os
                mensageiros, começando por Noé e terminando com Muhammad (que a
                paz e a bênção estejam com eles).
              </p>
              <p>Diz Deus, o Exaltado:</p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      وَمَآ أَرْسَلْنَا مِن قَبْلِكَ مِن رَّسُولٍ إِلَّا
                      نُوحِىٓ إِلَيْهِ أَنَّهُۥ لَآ إِلَـٰهَ إِلَّآ أَنَا۠
                      فَٱعْبُدُونِ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Jamais enviamos mensageiro algum antes de ti, sem que lhe
                      tivéssemos revelado que: Não há outra divindade além
                      deMim. Adora-Me, e serve-Me!
                    </p>
                  </>
                }
                quranIdex="21:25"
              />
              <p>
                Deus criou os homens e os gênios e o resto de Sua criação por
                conta do testemunho de fé, não há outra divindade além de Deus.
              </p>
              <p>
                Consequentemente, tudo neste universo se submete a Deus, a Quem
                pertence a criação e o domínio.
              </p>
              <p>Ele conhece todas as coisas.</p>
            </>
          }
        />
        <ArticleBlock
          text={
            <>
              <h3>O significado do testemunho de fé</h3>
              <p>
                O testemunho (la ilaha illa allah) compreende dois conceitos:
                negação e afirmação.
              </p>
              <p>
                <p>
                  Primeiro: o testemunho de fé nega o atributo da divindade em
                  tudo e em todos que não sejam Deus, o Exaltado.
                </p>
                <p>
                  Tudo que não seja Deus, como os anjos, os profetas e o resto
                  da humanidade, sem falar nos ídolos e regimes políticos
                  mundanos, não são deuses e nem merecem ser adorados.
                </p>
                <p>
                  Assim, a negação a esse respeito não é a negação da existência
                  de supostos deuses, e sim a negação da divindade que é
                  atribuída a eles.
                </p>
              </p>
              <p>
                Segundo: O testemunho de fé confirma a divindade de Deus e
                limita esta divindade a Ele somente. Isto é, o servo deve
                acreditar que Deus é o único e verdadeiro Deus, e coerentemente
                não dedicar qualquer ato de adoração a outra divindade que não
                seja Deus.
              </p>
              <p>
                Uma vez que a adoração, com todos os seus atos e ritos
                legítimos, deve ser dedicada somente ao Deus que a merece,
                portanto o verdadeiro Deus a quem a adoração deve ser dedicada é
                o único que goza de certos atributos, tais como:
              </p>
              <ul>
                <li>
                  Divindade, a Unicidade de Deus, que é único como o único Deus
                  verdadeiro, que não tem parceiros com quem dividir Seus
                  atributos divinos e nem Seu domínio. Ele é o Único as-Samad
                  (Absoluto);
                </li>
                <li>
                  Auto-suficiência. Deus não precisa de ninguém. Não necessita
                  de ajudantes, nem de esposa e nem de um filho;
                </li>
                <li>
                  A capacidade de fazer tudo. Nada existe que possa frustrar Sua
                  capacidade. Ele cria o que quer sem cansaço ou apoio. Se Ele
                  quiser fazer alguma coisa, Ele apenas diz “Faça-se” e faz-se;
                </li>
                <li>
                  A vida absoluta que não se deteriora nunca. Deus é Permanente
                  e Ele é al-Qayum;
                </li>
                <li>
                  Vigilância: Deus nunca dorme e nem se descuida, e jamais é
                  tomado pelo sono;
                </li>
                <li>
                  Propriedade exclusiva: Todas as coisas que existem pertencem a
                  Deus somente;
                </li>
                <li>
                  Conhecimento: O conhecimento de Deus abrange todo o universo e
                  nem o peso de uma formiga escapa ao Seu conhecimento. Ele
                  conhece o oculto e o aparente, o passado, o presente e o
                  futuro, e Ele conhece os mais profundos pensamentos do homem;
                </li>
                <li>
                  Orgulho e grandeza: Não há nada maior do que Deus, nem em Sua
                  essência ou em Sua grandeza, nem em Sua supremacia;
                </li>
                <li>
                  Beneficência misericordiosa: Deus não erra nem pune
                  injustamente, pelo contrário, Ele ama Seus devotos e perdoa os
                  pecados daqueles que se arrependem.
                </li>
              </ul>
              <p>
                Portanto, Aquele que possui tais atributos merece ser adorado.
              </p>
              <p>
                Deus, o Exaltado, afinal de contas, é o Único que possui tais
                atributos.
              </p>
              <p>
                Ele é o Rei, o Poderoso, o Sábio, Aquele que conhece o visível e
                o invisível, o Misericordioso, o Beneficente.
              </p>
              <p>
                Somente Aquele que possui tais atributos é o Deus Verdadeiro,
                que merece ser adorado e a quem toda a grandeza da criação se
                submete.
              </p>
              <p>
                Por esta razão, o testemunho de fé se constitui na negação da
                divindade de qualquer outro que não seja Deus e concede esta
                divindade a Deus somente, porque Ele é o Único Verdadeiro Deus.
              </p>
              <p>
                Somente Deus, que não possui qualquer imperfeição, é quem goza
                dos atributos da divindade.
              </p>
              <p>
                Portanto, devemos conhecer os atos de adoração para que os
                dediquemos a Deus somente.
              </p>
              <p>
                Uma vez cientes disso, saberemos que Ele criou as criaturas
                apenas para adorá-Lo.
              </p>
              <p>
                O homem, como parte de Suas criaturas, deve dedicar toda a sua
                vida adorando a Deus, deve estar ciente das normas de Deus com
                relação à sua vida.
              </p>
              <p>
                Assim, todas as coisas lícitas que ele praticar, intencionando
                ser uma forma de aproximá-lo de Deus, transforma-se em ato de
                adoração.
              </p>
              <p>
                Adoração é um termo que compreende toda expressão e ato,
                aparente ou oculto, que Deus ama.
              </p>
              <p>
                Tendo lido esta breve mensagem sobre o significado do testemunho
                de fé e seus requisitos, estará o leitor provavelmente ansioso
                para professá-lo e aplicar suas exigências que são obrigatórias
                para todo aquele que o profere?
              </p>
              <p>São requisitos:</p>
              <ul>
                <li>
                  A crença de que Deus é o verdadeiro Deus, a quem a adoração
                  deve ser dedicada. Ele é o Único que possui todos os atributos
                  de perfeição e Aquele que está isento de qualquer imperfeição;
                </li>
                <li>
                  A crença de que Deus é o Criador de todas as coisas
                  existentes, o Sustentador, o Doador da vida e da morte, o
                  Proprietário do universo, o Único Governante e Legislador;
                </li>
                <li>
                  A crença de que Deus possui os atributos da perfeição e que
                  não tem imperfeições, conforme Muhammad, o mensageiro de Deus
                  (SAWS) nos informou no Alcorão e na Sunna, as duas únicas
                  fontes pelas quais conhecemos os atributos de Deus. Se
                  Muhammad (SAWS) tivesse inventado mentiras sobre Deus,
                  certamente Ele o teria punido. Mas, pelo contrário, Deus o
                  amparou com milagres que provaram sua veracidade e sinceridade
                  na transmissão de seu Rabb. Diz Deus:
                </li>
              </ul>
              <ReciteQuran
                arabicText={
                  <>
                    <p>وَلَوْ تَقَوَّلَ عَلَيْنَا بَعْضَ ٱلْأَقَاوِيلِ ٤٤</p>
                    <p>لَأَخَذْنَا مِنْهُ بِٱلْيَمِينِ ٤٥</p>
                    <p>ثُمَّ لَقَطَعْنَا مِنْهُ ٱلْوَتِينَ ٤٦</p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E se (o Mensageiro) tivesse inventado alguns ditos, em
                      Nosso nome
                    </p>
                    <p>Certamente o teríamos apanhado pela destra;</p>
                    <p>E então, Ter-lhe-íamos cortado a aorta,</p>
                  </>
                }
                quranIdex="69:44-46"
              />
            </>
          }
        />
      </div>
      <div className="footerNotes">
        <p>Shaykh Hamoud M. Al-Lahim</p>
      </div>
      <FinishArticle />
    </DefaultPage>
  );
}

export const Head: HeadFC = () => {
  return (
    <SEO
      title="O significado do Testemunho de Fé | Mesquita da Luz"
      description="Será que temos a compreensão ampla da Shahada? Vamos nos aprofundar em sua beleza e significado"
      // schema={indexSchema}
    />
  );
};
